import axios from 'axios';
import { appUrl, smlUrl } from '../../../../../utils/config';

import { SCREENS_ACCESS, FEATURES_ACCESS } from '../types';

export const getScreensAccess = (data) => (dispatch) => {
  axios
    // .get(`${smlUrl}/user/getScreensAccess`, data)
    .get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/getScreensAccess`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: SCREENS_ACCESS,
          payload: res?.data,
        });
      }
    })
    .catch((err) => {
      console.log('Error in getScreensAccess:', err);
      // Dispatch empty payload to prevent undefined errors
      dispatch({
        type: SCREENS_ACCESS,
        payload: { status: false, data: {} },
      });
    });
};

export const getFeaturesAccess = (screenId, screenName) => (dispatch) => {
  axios
    // .get(`${smlUrl}/user/getFeaturesAccess/${screenId}`)
    .get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/getFeaturesAccess/${screenId}`)
    .then((res) => {
      if (res?.data?.status) {
        dispatch({
          type: FEATURES_ACCESS,
          payload: res.data.data,
          screenName,
        });
      } else {
        // Handle case where response doesn't have expected structure
        dispatch({
          type: FEATURES_ACCESS,
          payload: {},
          screenName,
        });
      }
    })
    .catch((err) => {
      console.log('Error in getFeaturesAccess:', err);
      // Dispatch empty payload to prevent null reference errors
      dispatch({
        type: FEATURES_ACCESS,
        payload: {},
        screenName,
      });
    });
};